var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.251099,
    width: 18.4979,
    height: 18.4979,
    rx: 2.84583,
    fill: "#2C7465"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3418 5.34984C10.3418 5.0224 10.0764 4.75696 9.74891 4.75696C9.42147 4.75696 9.15603 5.0224 9.15603 5.34984V8.90713H5.59874C5.2713 8.90713 5.00586 9.17257 5.00586 9.50001C5.00586 9.82745 5.2713 10.0929 5.59874 10.0929H9.15603V13.6502C9.15603 13.9776 9.42147 14.2431 9.74891 14.2431C10.0764 14.2431 10.3418 13.9776 10.3418 13.6502V10.0929H13.8991C14.2265 10.0929 14.492 9.82745 14.492 9.50001C14.492 9.17257 14.2265 8.90713 13.8991 8.90713H10.3418V5.34984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8cefdb5206251eda2c8fda5d1d83e06c.svg";
export { ForwardRef as ReactComponent };